import { motion } from "framer-motion";

const chapters = [
    {
        no: "01",
        title: "Policy",
        color: "text-[var(--gold)]",
        body: "We equip young leaders to shape the frameworks that govern our world — from climate treaties to digital rights — with clarity, evidence and moral courage.",
    },
    {
        no: "02",
        title: "People",
        color: "text-[var(--emerald)]",
        body: "Human dignity, human rights, human potential. Every program begins and ends with the person: their agency, their community, their voice.",
    },
    {
        no: "03",
        title: "Planet",
        color: "text-[var(--gold)]",
        body: "From the Climate Power Summit to sustainability curricula, we align every ZSGI initiative with the UN SDGs — because there is no leadership without a livable earth.",
    },
    {
        no: "04",
        title: "Peace",
        color: "text-[var(--emerald)]",
        body: "Dialogue over division. We train diplomats-in-the-making to hold complexity, mediate difference, and design institutions that outlast conflict.",
    },
    {
        no: "05",
        title: "Progress",
        color: "text-[var(--gold)]",
        body: "Impact is measured, not assumed. Our graduates leave with portfolios, partners, and plans — commitments that stand up to the world.",
    },
];

const item = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.05, duration: 0.7, ease: [0.76, 0, 0.24, 1] },
    }),
};

export default function ManifestoChapters() {
    return (
        <section data-testid="manifesto-section" className="section-ivory py-24 md:py-40">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
                <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-24">
                    <div className="md:col-span-4">
                        <div className="label-mono text-[var(--gold-dark)] text-[color:#8F6F26]">— MANIFESTO</div>
                    </div>
                    <div className="md:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                            className="serif-display text-4xl md:text-6xl lg:text-7xl text-[var(--navy)]"
                        >
                            Five words we refuse to <span className="serif-italic">separate.</span>
                        </motion.h2>
                    </div>
                </div>

                <div className="grid gap-0 divide-y divide-[rgba(11,30,63,0.15)] border-t border-b border-[rgba(11,30,63,0.15)]">
                    {chapters.map((c, i) => (
                        <motion.div
                            key={c.no}
                            data-testid={`manifesto-chapter-${c.no}`}
                            custom={i}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-80px" }}
                            variants={item}
                            className="grid md:grid-cols-12 gap-10 py-12 md:py-16 group"
                        >
                            <div className="md:col-span-2 flex items-start">
                                <span className={`serif-display text-6xl md:text-7xl ${c.color}`}>{c.no}</span>
                            </div>
                            <div className="md:col-span-4">
                                <h3 className="serif-display text-4xl md:text-6xl text-[var(--navy)]">
                                    {c.title}<span className="text-[var(--gold)]">.</span>
                                </h3>
                            </div>
                            <div className="md:col-span-6">
                                <p className="text-lg md:text-xl leading-relaxed text-[var(--navy)]/80">{c.body}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
